export { cn } from '@/utils/cn'

export function enumToOptions<T extends string>(labels: Record<T, string>): { value: T; label: string }[] {
  return Object.entries(labels).map(([value, label]) => ({
    value: value as T,
    label: label as string,
  }))
}

export {
  formatCurrency,
  formatDate,
  formatDateForApi,
  formatDateTime,
  formatDuration,
  formatRelativeDate,
} from './formatters'
